import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mergeStyles, isValidHref } from 'wix-rich-content-common';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { TextInput, ErrorIcon, Checkbox, CollapseButton, Collapse } from 'wix-rich-content-ui-components';
import AdvancedCheckboxes from './AdvancedCheckboxes.js';
import { s as styles } from '../../link-panel-d6b164a2.js';
import { LinkPanelDropdown } from './LinkPanelDropdown.js';
import './consts.js';
import '../../style-inject.es-746bb8ed.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a, _b;
class LinkPanel extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { showValidation: false, showAdvancedSettings: false });
    __publicField(this, "textInput", React.createRef());
    __publicField(this, "styles", mergeStyles({ styles, theme: this.props.theme }));
    __publicField(this, "useAdvancedSettings", !!((_b = (_a = this.props.experiments) == null ? void 0 : _a.useLinkSeo) == null ? void 0 : _b.enabled));
    __publicField(this, "handleUrlChange", (url) => {
      this.setState({ showValidation: false });
      this.onChange({
        url,
        isValid: this.isValidUrl(url)
      });
    });
    __publicField(this, "toggleAdvancedSettings", () => {
      this.setState({ showAdvancedSettings: !this.state.showAdvancedSettings });
    });
    __publicField(this, "handleTargetChange", (event) => {
      this.onChange({ targetBlank: event.target.checked });
    });
    __publicField(this, "handleNofollowChange", (event) => {
      this.onChange({ nofollow: event.target.checked });
    });
    __publicField(this, "handleNoreferrerChange", (event) => {
      this.onChange({ noreferrer: event.target.checked });
    });
    __publicField(this, "handleSponsoredChange", (event) => {
      this.onChange({ sponsored: event.target.checked });
    });
    __publicField(this, "handleNoReferrerChange", (event) => {
      this.onChange({ noreferrer: event.target.checked });
    });
    __publicField(this, "onChange", (changes) => this.props.onChange(__spreadValues(__spreadValues({}, this.props.linkValues), changes)));
    __publicField(this, "handleKeyDown", (e) => {
      const { onEnter, onEscape } = this.props;
      if (e.key === "Enter") {
        this.setState({ showValidation: true });
        e.preventDefault();
        onEnter && onEnter(e);
      } else if (e.key === "Escape") {
        e.preventDefault();
        onEscape && onEscape(e);
      }
    });
    __publicField(this, "isValidUrl", (url) => !url || isValidHref(url));
    __publicField(this, "getInput", () => {
      return this.props.dropDown ? this.getDropdown() : this.getTextInput();
    });
    __publicField(this, "getCheckboxesData", () => {
      const { showNoReferrerCheckbox, showNoFollowCheckbox, showSponsoredCheckbox, t, linkValues } = this.props;
      const { noreferrer, nofollow, sponsored } = linkValues;
      return [
        {
          showCheckbox: showNoReferrerCheckbox,
          label: t("LinkPanel_Noreferrer_Checkbox_Label"),
          checked: noreferrer,
          dataHook: "linkPanelNoreferrerCheckbox",
          onChange: this.handleNoReferrerChange,
          tooltipTextKey: t("LinkPanel_Noreferrer_Tooltip")
        },
        {
          showCheckbox: showNoFollowCheckbox,
          label: this.useAdvancedSettings ? t("LinkPanel_Nofollow_Checkbox_Label") : t("LinkPanel_Nofollow_Checkbox"),
          checked: nofollow,
          dataHook: "linkPanelRelCheckbox",
          onChange: this.handleNofollowChange,
          tooltipTextKey: this.useAdvancedSettings ? t("LinkPanel_Nofollow_Tooltip") : t("LinkPanel_Nofollow_Checkbox_Tooltip")
        },
        {
          showCheckbox: showSponsoredCheckbox,
          label: this.useAdvancedSettings ? t("LinkPanel_Sponsored_Checkbox_Label") : t("LinkPanel_Sponsored_Checkbox"),
          checked: sponsored,
          dataHook: "linkPanelSponsoredCheckbox",
          onChange: this.handleSponsoredChange,
          tooltipTextKey: this.useAdvancedSettings ? t("LinkPanel_Sponsored_Tooltip") : t("LinkPanel_Sponsored_Checkbox_Tooltip")
        }
      ];
    });
    __publicField(this, "renderAdvancedCheckboxes", () => {
      const { isMobile, t, langDir } = this.props;
      return /* @__PURE__ */ React.createElement(
        AdvancedCheckboxes,
        {
          checkboxesData: this.getCheckboxesData(),
          useAdvancedSettings: this.useAdvancedSettings,
          isMobile,
          langDir,
          t
        }
      );
    });
  }
  componentDidMount() {
    var _a2;
    this.onChange({ isValid: this.isValidUrl(this.props.linkValues.url) });
    setTimeout(() => {
      var _a3;
      return (_a3 = this.textInput.current) == null ? void 0 : _a3.focus();
    }, 0);
    (_a2 = this.textInput.current) == null ? void 0 : _a2.select();
    this.setState({ showAdvancedSettings: !this.isRelEqualToDefault() });
  }
  isRelEqualToDefault() {
    const {
      relValue,
      linkValues: { noreferrer, nofollow, sponsored }
    } = this.props;
    const currentValue = { noreferrer, nofollow, sponsored };
    const defaultValue = {
      noreferrer: relValue.includes("noreferrer"),
      nofollow: relValue.includes("nofollow"),
      sponsored: relValue.includes("sponsored")
    };
    return JSON.stringify(defaultValue) === JSON.stringify(currentValue);
  }
  hasError() {
    return this.props.linkValues.isValid === false && this.state.showValidation;
  }
  getDropdown() {
    return /* @__PURE__ */ React.createElement(
      LinkPanelDropdown,
      __spreadValues({
        theme: this.props.theme,
        value: this.props.linkValues.url,
        onChange: this.handleUrlChange,
        textInputProps: this.getTextInputProps(),
        t: this.props.t
      }, this.props.dropDown)
    );
  }
  getTextInput() {
    return /* @__PURE__ */ React.createElement(
      TextInput,
      __spreadValues({
        placeholder: this.props.t("LinkPanel_InputPlaceholder"),
        inputRef: this.textInput,
        value: this.props.linkValues.url,
        onChange: this.handleUrlChange
      }, this.getTextInputProps())
    );
  }
  getTextInputProps() {
    const { styles: styles2 } = this;
    const textInputClassName = classNames(styles2.linkPanel_textInput, {
      [styles2.linkPanel_textInput_invalid]: this.hasError()
    });
    return {
      type: "url",
      className: textInputClassName,
      placeholder: this.props.placeholder || this.props.t("LinkPanel_InputPlaceholder"),
      "data-hook": "linkPanelInput",
      onBlur: () => this.setState({ showValidation: true })
    };
  }
  render() {
    const { styles: styles2 } = this;
    const { theme, ariaProps, showNewTabCheckbox, t, linkValues, hideUrlInput, hasCheckboxes } = this.props;
    const { targetBlank } = linkValues;
    return /* @__PURE__ */ React.createElement(
      "div",
      __spreadProps(__spreadValues({
        className: classNames(styles2.linkPanel_Content, {
          [styles2.basicPanel]: !hasCheckboxes
        })
      }, ariaProps), {
        role: "form"
      }),
      !hideUrlInput && /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
      /* @__PURE__ */ React.createElement("div", { className: styles2.linkPanel_Input, onKeyDown: this.handleKeyDown }, this.getInput(), this.hasError() && /* @__PURE__ */ React.createElement(Tooltip, { content: t("LinkPanel_ErrorTooltip"), isError: true }, /* @__PURE__ */ React.createElement(ErrorIcon, { "data-hook": "linkPanelError", className: styles2.linkPanel_errorIcon }))),
      hasCheckboxes && /* @__PURE__ */ React.createElement("div", { className: styles2.checkboxesContainer }, showNewTabCheckbox && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles2.linkPanel_checkbox, {
            [styles2.linkPanel_advanced_checkbox]: this.useAdvancedSettings
          })
        },
        /* @__PURE__ */ React.createElement(
          Checkbox,
          {
            label: t("LinkPanel_Target_Checkbox"),
            theme,
            checked: targetBlank,
            dataHook: "linkPanelBlankCheckbox",
            onChange: this.handleTargetChange
          }
        )
      ), this.useAdvancedSettings ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        CollapseButton,
        {
          isOpen: this.state.showAdvancedSettings,
          label: t("LinkPanel_AdvancedSettings_Label"),
          onClick: this.toggleAdvancedSettings,
          dataHook: "linkPanelAdvancedSettings"
        }
      ), /* @__PURE__ */ React.createElement(Collapse, { isOpen: this.state.showAdvancedSettings }, this.renderAdvancedCheckboxes())) : this.renderAdvancedCheckboxes())
    );
  }
}
__publicField(LinkPanel, "defaultProps", {
  showNewTabCheckbox: true,
  showNoFollowCheckbox: true,
  showNoReferrerCheckbox: true,
  showSponsoredCheckbox: false,
  hasCheckboxes: true,
  isMobile: false
});
LinkPanel.propTypes = {
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  linkValues: PropTypes.shape({
    url: PropTypes.string,
    isValid: PropTypes.bool,
    targetBlank: PropTypes.bool,
    nofollow: PropTypes.bool,
    sponsored: PropTypes.bool,
    noreferrer: PropTypes.bool
  }).isRequired,
  ariaProps: PropTypes.object,
  showNewTabCheckbox: PropTypes.bool,
  showNoFollowCheckbox: PropTypes.bool,
  showNoReferrerCheckbox: PropTypes.bool,
  showSponsoredCheckbox: PropTypes.bool,
  dropDown: PropTypes.object,
  experiments: PropTypes.object,
  onEnter: PropTypes.func,
  onEscape: PropTypes.func,
  placeholder: PropTypes.string,
  hideUrlInput: PropTypes.bool,
  isMobile: PropTypes.bool,
  hasCheckboxes: PropTypes.bool,
  anchorTarget: PropTypes.string,
  langDir: PropTypes.string,
  relValue: PropTypes.string
};

export { LinkPanel as default };
//# sourceMappingURL=LinkPanel.js.map
